// extracted by mini-css-extract-plugin
module.exports = {"cls1":"styles-Section-module--cls1--3d_dF","cls2":"styles-Section-module--cls2--1WZr3 styles-Section-module--cls1--3d_dF"};